import alasql from 'alasql'

export function getRegiones() {
	return alasql("SELECT cod_zona, 'REGIÓN ' + glosa_zona as glosa_zona, orden_zona FROM zonas WHERE tipo_zona = 'R'")
}

export function getElecciones() {
	return alasql('SELECT * FROM elecciones')
}

export function getZonasByTipo(tipoZona) {
	return alasql('SELECT * FROM zonas WHERE tipo_zona = ?', [tipoZona])
}

export function getCandidatos() {
	return alasql('SELECT * FROM candidatos')
}

export function getComunas(codZonaRegion) {
	const result = alasql(
		`
			SELECT comunas.cod_zona, comunas.glosa_zona, comunas.orden_zona, regiones.cod_zona AS region_cod_zona, 'REGIÓN ' + regiones.glosa_zona AS region_glosa_zona, distritos.cod_zona AS distrito_cod_zona, distritos.glosa_zona AS distrito_glosa_zona
			FROM zonas AS comunas
			LEFT JOIN zonas_padre AS padres_comunas ON comunas.cod_zona = padres_comunas.cod_zona AND padres_comunas.tipo_zona = 'C'
			LEFT JOIN zonas AS distritos ON padres_comunas.cod_zona_pad = distritos.cod_zona AND padres_comunas.tipo_zona_pad = 'D'
			LEFT JOIN zonas_padre AS provincias_regiones ON padres_comunas.cod_zona_pad = provincias_regiones.cod_zona AND padres_comunas.tipo_zona_pad = 'Q'
			LEFT JOIN zonas AS regiones ON provincias_regiones.cod_zona_pad = regiones.cod_zona AND provincias_regiones.tipo_zona_pad = 'R' 
			${codZonaRegion ? 'AND provincias_regiones.cod_zona_pad = ?' : ''}
			WHERE comunas.tipo_zona = 'C'
		`,
		[codZonaRegion]
	) // NO SÉ SQL O ES PROBLEMA DE LOS JOIN DE ALASQL, así que a hacer left join y merge

	const resultsMap = {}

	result.forEach(comuna => {
		if (!resultsMap[comuna.cod_zona]) {
			resultsMap[comuna.cod_zona] = comuna
		} else {
			resultsMap[comuna.cod_zona] = {
				...JSON.parse(JSON.stringify(resultsMap[comuna.cod_zona])),
				...JSON.parse(JSON.stringify(comuna))
			}
		}
	})

	return Object.values(resultsMap).sort((a, b) => a.cod_zona - b.cod_zona)
}

export function getDistritos(codZonaRegion) {
	return alasql(
		`
			SELECT distritos.cod_zona, distritos.glosa_zona, distritos.orden_zona, regiones.cod_zona AS region_cod_zona, 'REGIÓN ' + regiones.glosa_zona AS region_glosa_zona
			FROM zonas AS distritos 
			JOIN zonas_padre AS distritos_circunscripcion_senatorial ON distritos.cod_zona = distritos_circunscripcion_senatorial.cod_zona AND distritos.tipo_zona = 'D'
			JOIN zonas_padre AS circunscripcion_senatorial_regiones ON distritos_circunscripcion_senatorial.cod_zona_pad = circunscripcion_senatorial_regiones.cod_zona AND distritos_circunscripcion_senatorial.tipo_zona_pad = 'S'
			JOIN zonas AS regiones ON circunscripcion_senatorial_regiones.cod_zona_pad = regiones.cod_zona AND circunscripcion_senatorial_regiones.tipo_zona_pad = 'R' 
			${codZonaRegion ? 'AND circunscripcion_senatorial_regiones.cod_zona_pad = ?' : ''}
		`,
		[codZonaRegion]
	)
}

export function getVotos(codZona, tipoZona, codElec) {
	// O NUEVAMENTE NO SÉ HACER JOINS O EL LEFT JOIN DE VOTACION + WHERE NO FUNCIONAN CORRECTAMENTE EN ALASQL
	// SOLO QUEDA HACER JOIN MANUAL
	const candidatos = alasql(
		`SELECT candidatos.cod_cand, glosa_cand, pactos.cod_pacto, pactos.glosa_pacto, partidos.cod_part, partidos.glosa_part, can_orden
		FROM candidatos 
		JOIN pactos ON candidatos.cod_pacto = pactos.cod_pacto
		JOIN partidos ON candidatos.cod_part = partidos.cod_part
		JOIN elecciones ON candidatos.cod_elec = elecciones.cod_elec
		WHERE candidatos.cod_zona = ? AND elecciones.tipo_zona = ? AND candidatos.cod_elec = ?`,
		[codZona, tipoZona, codElec]
	)

	const votos = alasql(
		`SELECT votacion.cod_ambito AS cod_cand, votacion.votos
		FROM votacion
		WHERE votacion.cod_zona = ? AND votacion.tipo_zona = ? AND votacion.cod_elec = ? AND votacion.ambito = 4`,
		[codZona, tipoZona, codElec]
	)

	const candidatosMap = {}

	candidatos.forEach(candidato => {
		candidatosMap[candidato.cod_cand] = candidato
		candidato.votos = 0
	})

	votos.forEach(voto => {
		candidatosMap[voto.cod_cand].votos = voto.votos
	})

	return candidatos.concat(
		alasql(
			`SELECT 1 as cod_cand, 
			CASE ambito WHEN 5 THEN 'Nulos' WHEN 6 THEN 'Blancos' WHEN 7 THEN 'Votos válidos' END glosa_cand, 
			CASE ambito WHEN 5 THEN 3 WHEN 6 THEN 2 WHEN 7 THEN 1 END can_orden, 
			votos 
			FROM votacion WHERE votacion.cod_zona = ? AND votacion.tipo_zona = ? AND votacion.cod_elec = ? AND votacion.ambito IN(5,6,7)`,
			[codZona, tipoZona, codElec]
		)
	)
}

export function getVotosGobernadores() {
	// O NUEVAMENTE NO SÉ HACER JOINS O EL LEFT JOIN DE VOTACION + WHERE NO FUNCIONAN CORRECTAMENTE EN ALASQL
	// SOLO QUEDA HACER JOIN MANUAL
	const candidatos = alasql(
		`SELECT candidatos.cod_cand, candidatos.cod_genero, candidatos.cod_zona, glosa_cand, pactos.cod_pacto, pactos.glosa_pacto, partidos.cod_part, partidos.glosa_part, can_orden
		FROM candidatos 
		JOIN pactos ON candidatos.cod_pacto = pactos.cod_pacto
		JOIN partidos ON candidatos.cod_part = partidos.cod_part
		JOIN elecciones ON candidatos.cod_elec = elecciones.cod_elec
		WHERE elecciones.tipo_zona = 'R' AND candidatos.cod_elec = 1`
	)

	const votos = alasql(
		`SELECT votacion.cod_ambito AS cod_cand, votacion.votos
		FROM votacion
		WHERE votacion.tipo_zona = 'R' AND votacion.cod_elec = 1 AND votacion.ambito = 4`
	)

	const candidatosMap = {}

	candidatos.forEach(candidato => {
		candidatosMap[candidato.cod_cand] = candidato
		candidato.votos = 0
	})

	votos.forEach(voto => {
		candidatosMap[voto.cod_cand].votos = voto.votos
	})

	return candidatos.concat(
		alasql(
			`SELECT 1 as cod_cand, 
			cod_zona,
			CASE ambito WHEN 5 THEN 'Nulos' WHEN 6 THEN 'Blancos' WHEN 7 THEN 'Votos válidos' END glosa_cand, 
			CASE ambito WHEN 5 THEN 3 WHEN 6 THEN 2 WHEN 7 THEN 1 END can_orden, 
			votos 
			FROM votacion WHERE votacion.tipo_zona = 'R' AND votacion.cod_elec = 1 AND votacion.ambito IN(5,6,7)`
		)
	)
}

export function getVotosPrimarias() {
	// O NUEVAMENTE NO SÉ HACER JOINS O EL LEFT JOIN DE VOTACION + WHERE NO FUNCIONAN CORRECTAMENTE EN ALASQL
	// SOLO QUEDA HACER JOIN MANUAL
	const candidatos = alasql(
		`SELECT candidatos.cod_cand, candidatos.cod_genero, candidatos.cod_zona, glosa_cand, pactos.cod_pacto, pactos.glosa_pacto, partidos.cod_part, partidos.glosa_part, can_orden
		FROM candidatos 
		JOIN pactos ON candidatos.cod_pacto = pactos.cod_pacto
		JOIN partidos ON candidatos.cod_part = partidos.cod_part
		JOIN elecciones ON candidatos.cod_elec = elecciones.cod_elec
		WHERE elecciones.tipo_zona = 'G' AND candidatos.cod_elec = 4`
	)

	const votos = alasql(
		`SELECT votacion.cod_ambito AS cod_cand, votacion.votos
		FROM votacion
		WHERE votacion.tipo_zona = 'G' AND votacion.cod_elec = 4 AND votacion.ambito = 4`
	)

	const candidatosMap = {}

	candidatos.forEach(candidato => {
		candidatosMap[candidato.cod_cand] = candidato
		candidato.votos = 0
	})

	votos.forEach(voto => {
		candidatosMap[voto.cod_cand].votos = voto.votos
	})

	return candidatos.concat(
		alasql(
			`SELECT 1 as cod_cand, 
			cod_zona,
			CASE ambito WHEN 5 THEN 'Nulos' WHEN 6 THEN 'Blancos' WHEN 7 THEN 'Votos válidos' END glosa_cand, 
			CASE ambito WHEN 5 THEN 3 WHEN 6 THEN 2 WHEN 7 THEN 1 END can_orden, 
			votos 
			FROM votacion WHERE votacion.tipo_zona = 'G' AND votacion.cod_elec = 4 AND votacion.ambito IN(5,6,7)`
		)
	)
}
